export default __webpack_public_path__ + "static/media/facebook-light.6faec23d.svg";